import fetch from '@/utils/fetch'

// 核验员分页查询复审任务
export function getReexaminePage(params) {
  return fetch({
    url: '/api/artificial/abnormal/reexamine/task/page',
    method: 'get',
    params
  })
}

// 核验员分页查询复审任务批次
export function getReexamineBatchPage(params) {
  return fetch({
    url: '/api/artificial/abnormal/reexamine/batch/userPage',
    method: 'get',
    params
  })
}

// 核验员查询复审任务下一条详情
export function getReexamineNextDetail(batchId) {
  return fetch({
    url: `/api/artificial/abnormal/reexamine/batch/${batchId}/next`,
    method: 'get'
  })
}

// 获取复审跳单任务
export function getReexamineSkipedTask() {
  return fetch({
    url: `/api/artificial/abnormal/reexamine/batch/getUserSkipedReexamineTaskVO`,
    method: 'get'
  })
}

// 提交复审任务
export function submitReexamineTask(data) {
  return fetch({
    url: '/api/artificial/abnormal/reexamine/task/submit',
    method: 'post',
    data
  })
}

// 复审任务详情
export function getReexamineTaskDetail(id) {
  return fetch({
    url: `/api/artificial/abnormal/reexamine/task/detail/${id}`,
    method: 'get'
  })
}

// 获取兼职复审是否有可领取任务
export function reexamineBatchExistPartTask() {
  return fetch({
    url: '/api/artificial/abnormal/reexamine/batch/existPartTask',
    method: 'get'
  })
}
